import { observer } from 'mobx-react';
import { FC, useMemo } from 'react';
import ItemsForDealModalHeaderControls from '../../components/ItemsForDealModalHeaderControls/ItemsForDealModalHeaderControls';
import ItemsForDealModalHeaderSearchBlock from '../../components/ItemsForDealModalHeaderSearchBlock/ItemsForDealModalHeaderSearchBlock';
import { itemsForDealModalStore } from '../../store';
import { localeStore } from 'src/mobx/localesStore';
import { MODALS_CRUMB } from 'src/types/main';
import Crumbs from '~/view/components/Controls/Crumbs';

const ItemsForDealModalHeader: FC = observer((): JSX.Element => {
  const { isMulti, activeCrumb, selectedItems, changeCrumb } = itemsForDealModalStore;

  const selectedItemsNumber = useMemo((): number | null => {
    return isMulti ? selectedItems.length : null;
  }, [isMulti, selectedItems]);

  const crumbs = useMemo(() => {
    return [
      { label: localeStore.t('all'), value: MODALS_CRUMB.ALL },
      { label: localeStore.t('selected') + ` ${selectedItemsNumber ? selectedItemsNumber : ''}`, value: MODALS_CRUMB.SELECTED },
    ];
  }, [selectedItemsNumber]);

  if (isMulti) {
    return (
      <div className="custom-modal-header">
        {/* search and category picker */}
        <ItemsForDealModalHeaderSearchBlock />

        <div className="d-flex flex-row justify-content-between mt-4">
          {/* all/selected crumbs */}
          <Crumbs crumbs={crumbs} activeCrumb={activeCrumb} onClick={changeCrumb} />
          {/* select/deselect buttons */}
          <ItemsForDealModalHeaderControls />
        </div>
      </div>
    );
  }

  return (
    <div className="custom-modal-header">
      <div className="d-flex flex-row align-items-bottom justify-content-between">
        {/* search and category picker */}
        <ItemsForDealModalHeaderSearchBlock />
        {/* select/deselect buttons */}
        <ItemsForDealModalHeaderControls />
      </div>
    </div>
  );
});

export default ItemsForDealModalHeader;
